import { LineChart } from '@carrent/ui'
import { RUB } from './format'

/**
 * Гаджет: пробег парка.
 *
 * Два разных числа рядом: накопленный одометр говорит о возрасте парка,
 * километры за период — о текущей нагрузке. Подписи разведены, чтобы
 * их не читали как одну величину.
 */
export function FleetMileageWidget({ data }) {
  if (!data.cars) {
    return <p className="widget-empty">В парке нет машин</p>
  }

  return (
    <div className="mileage">
      <div className="mileage__pair">
        <span className="mileage__block">
          <span className="mileage__value">{RUB.format(data.period_distance)} км</span>
          <span className="mileage__label">за {data.period_days ?? '—'} дн.</span>
        </span>
        <span className="mileage__block">
          <span className="mileage__value mileage__value--muted">
            {RUB.format(data.odometer_total)} км
          </span>
          <span className="mileage__label">одометр парка</span>
        </span>
      </div>

      <p className="mileage__avg">
        В среднем {RUB.format(data.period_avg_per_car)} км на машину
        за период, {RUB.format(data.odometer_avg)} км накоплено
      </p>

      {data.daily.length > 1 && (
        <LineChart
          data={data.daily}
          valueKey="distance"
          label="Пробег по дням"
          formatValue={(v) => `${RUB.format(v)} км`}
        />
      )}

      {data.top.length > 0 && (
        <ul className="widget-list">
          {data.top.map((c) => (
            <li key={c.car_id} className="mileage__row">
              <span className="mileage__car">
                {c.car}
                {c.plate ? <span className="plate">{c.plate}</span> : null}
              </span>
              <span className="mileage__dist">{RUB.format(c.distance)} км</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
